module.exports = __webpack_public_path__ + "static/media/chevron-left-double.5872269c.svg";